import MenuCard from "./MenuCard";

export {MenuCard}
export default MenuCard
